import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import KizenTypography from 'app/kizentypo';
import Icon from 'components/Kizen/Icon';
import { fontSizes } from 'app/typography';

const Container = styled.div`
  display: flex;
  cursor: pointer;
  margin-bottom: -1px; // matches Section's Header > h4 style
  i {
    margin-top: -1px;
  }
`;

const StyledIcon = styled(Icon)`
  margin-right: 8px;
  font-weight: bold;
  font-size: ${fontSizes.text};
`;

export const TrayBackButton = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Container onClick={onClick}>
      <StyledIcon
        icon="chevron-left"
        size="1x"
        color="var(--color-border-medium-light)"
      />
      <KizenTypography
        as="h4"
        weight="bold"
        size="buttonLabel"
        textTransform="uppercase"
        color="var(--color-border-medium-light)"
      >
        {t('Build')}
      </KizenTypography>
    </Container>
  );
};
